export type TransformParams = { from: string; to: string };

/*
 * Due to a bug in the SecureRoutes Component,
 * Code= can not be present in the URL.
 */
export default function transformKeys(
  action: "to" | "back",
  searchParams: object
) {
  // Add your params here to transform them.
  const keysToTransform: TransformParams[] = [
    { from: "correspondentCode", to: "correspondentKey" },
  ];

  let newSearchParams = new URLSearchParams({ ...searchParams });
  newSearchParams.forEach((value, key) => {
    if (value === "undefined" || value === "STATUS_UNSPECIFIED") {
      newSearchParams.delete(key);
    }

    const isInList = !!keysToTransform.find(k => k.from === key);
    const containsCode = key.toLowerCase().includes("code");

    if (!isInList && containsCode) {
      console.warn(`
      🔥 WARNING 🔥
      The word 'code' is being used as a url search query param in ${key}.
      Okta <SecureRoute> will not render this page correctly on reload.
      Please change your param to NOT use 'code'.
      Or update the 'Hooks/useSearchBarParams/transformKeys.ts' in the common-library
      to handle your new query param.
      `);
    }
  });

  if (action === "to") {
    keysToTransform.forEach(key => {
      const valueToKeep = newSearchParams.get(key.from);
      if (valueToKeep) {
        newSearchParams.set(key.to, valueToKeep);
        newSearchParams.delete(key.from);
      }
    });
  }

  if (action === "back") {
    keysToTransform.forEach(key => {
      const valueToKeep = newSearchParams.get(key.to);
      if (valueToKeep) {
        newSearchParams.set(key.from, valueToKeep);
        newSearchParams.delete(key.to);
      }
    });
  }

  return Object.fromEntries(newSearchParams.entries());
}
